module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/inactive/bft-6ea3cb203ff84c855cf0cba4d34f3d7d.png";